import vars from './vars';
import similar from './similar';
import mobileBg from './mobile-bg';

export default {
	goToMain() {
		vars.$body.addClass('page-home');
		vars.$footer.removeClass('is-hidden');
		vars.$footerShare.removeClass('is-hidden');
		vars.$footerInfo.removeClass('is-hidden');
		vars.$home.removeClass('is-hidden');

		vars.$navLink.filter('[href="/"]').addClass('is-active');

		if (innerWidth < 561) {
			vars.$footerArticle.removeClass('is-hidden');
		}

		mobileBg.show();
	},

	goToArticle(name) {
		vars.$body.addClass('page-article');

		let $article = vars.$article.filter(`[data-article="${name}"]`);

		$article.removeClass('is-hidden');
		vars.$headerBackHome.removeClass('is-hidden');
		vars.$footer.removeClass('is-hidden');
		vars.$footerArticle.removeClass('is-hidden');

		if (location.href.indexOf('develop')) {
			let warningHeight = $article.find($('.article__content')).height() / 100 * 5;

			$('.article__warning').css({
				'height': `${warningHeight}px`,
				'background-size': '100% 100%',
			});
		}

		vars.$navLink.filter(`[href="/article/${name}"]`).addClass('is-active');

		similar.article($article.index('.article'));
	},

	goFromMainToArticle(name) {
		return new Promise((resolve) => {
			vars.$html.addClass('is-animating');
			vars.$body.removeAttr('class').addClass('page-article');

			let $article = vars.$article.filter(`[data-article="${name}"]`);

			vars.$footerShare.addClass('is-hidden');
			vars.$footerInfo.addClass('is-hidden');
			vars.$footerArticle.removeClass('is-hidden');
			vars.$headerBackHome.removeClass('is-hidden');

			vars.$navLink.removeClass('is-active');
			vars.$navLink.filter(`[href="/article/${name}"]`).addClass('is-active');

			similar.article($article.index('.article'));

			new TimelineMax({
				onComplete() {
					vars.$html.removeClass('is-animating');
					resolve();
				},
			})
				.to(vars.$home, 0.5, {
					autoAlpha: 0,
					clearProps: 'all',
					onComplete() {
						window.scrollTo(0, 0);
						vars.$home.addClass('is-hidden');
						$article.removeClass('is-hidden');
						mobileBg.destroy();
					},
				})
				.fromTo($article, 0.5, {
					autoAlpha: 0,
				}, {
					autoAlpha: 1,
					clearProps: 'all',
				});
		});
	},

	goFromArticleToMain() {
		return new Promise((resolve) => {
			vars.$html.addClass('is-animating');
			vars.$body.removeAttr('class').addClass('page-home');

			let $article = vars.$article.not('.is-hidden');

			vars.$footerShare.removeClass('is-hidden');
			vars.$footerInfo.removeClass('is-hidden');
			vars.$headerBackHome.addClass('is-hidden');

			vars.$navLink.removeClass('is-active');
			vars.$navLink.filter('[href="/"]').addClass('is-active');

			if (innerWidth > 560) {
				vars.$footerArticle.addClass('is-hidden');
			}

			new TimelineMax({
				onComplete() {
					window.scrollTo(0, 0);
					vars.$html.removeClass('is-animating');
					resolve();
				},
			})
				.to($article, 0.5, {
					autoAlpha: 0,
					clearProps: 'all',
					onComplete() {
						$article.addClass('is-hidden');
						vars.$home.removeClass('is-hidden');
						mobileBg.show();
					},
				})
				.fromTo(vars.$home, 0.5, {
					autoAlpha: 0,
				}, {
					autoAlpha: 1,
					clearProps: 'all',
				});
		});
	},

	goFromArticleToArticle(name) {
		return new Promise((resolve) => {
			vars.$html.addClass('is-animating');

			let $articleCurrent = vars.$article.not('.is-hidden');
			let $article = vars.$article.filter(`[data-article="${name}"]`);

			vars.$navLink.removeClass('is-active');
			vars.$navLink.filter(`[href="/article/${name}"]`).addClass('is-active');

			new TimelineMax({
				onComplete() {
					vars.$html.removeClass('is-animating');
					resolve();
				},
			})
				.to($articleCurrent, 0.5, {
					autoAlpha: 0,
					clearProps: 'all',
					onComplete() {
						window.scrollTo(0, 0);
						$articleCurrent.addClass('is-hidden');
						$article.removeClass('is-hidden');

						similar.article($article.index('.article'));
					},
				})
				.fromTo($article, 0.5, {
					autoAlpha: 0,
				}, {
					autoAlpha: 1,
					clearProps: 'all',
				});
		});
	},
};
